import { ActionLog, TMethod } from '~/services/fullstory/action-log';
import { ILogger, INetworkStore } from '~/types/dependency.types';

interface IActionLoggerServiceProps {
    logger: ILogger;
    networkStore: INetworkStore;
}

export class ActionLoggerService {
    private logger: ILogger;
    private networkStore: INetworkStore;
    actionLog: ActionLog;

    constructor({ logger, networkStore }: IActionLoggerServiceProps) {
        this.logger = logger;
        this.networkStore = networkStore;
    }

    initActionLog() {
        if (this.actionLog) {
            this.logActionLog();
        }

        this.actionLog = new ActionLog({ networkStore: this.networkStore });

        return this.actionLog;
    }

    logActionLog() {
        if (!this.actionLog) {
            return;
        }

        const {
            generalDataString,
            commandsData: { create, update, delete: deleteArray }
        } = this.actionLog;

        this.logger.debug(
            `${generalDataString} | commands: total count: ${
                create.length + update.length + deleteArray.length
            }${this.addCommandsTypeString(
                create,
                'create'
            )}${this.addCommandsTypeString(
                update,
                'update'
            )}${this.addCommandsTypeString(deleteArray, 'delete')}`
        );

        this.actionLog = null;
    }

    addCommandsTypeString(commands: Array<string>, type: TMethod) {
        if (!commands.length) {
            return '';
        }

        return ` | ${type}: count: ${commands.length} data: ${commands.join(
            ' | '
        )} `;
    }
}
